import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { IconButton, Stack } from '@mui/material';
import { useMemo } from 'react';

import { useDataProvider } from '@work4all/data';

import { ContactTelephonenumbers } from '@work4all/models/lib/Classes/ContactTelephonenumbers.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { SdObjType } from '@work4all/models/lib/Enums/SdObjType.enum';

import { useCallModalContext } from './call-modal/useCallModalContext';

export class ContactActionProps {
  businessPartnerType?: SdObjType;
  businessPartnerId?: number;
  id?: number;
  eMail?: string;
  displayEMail?: boolean;
  displayPhone?: boolean;
  noButtonPadding?: boolean;
}

export const useContactActions = (props: ContactActionProps) => {
  const {
    businessPartnerType,
    businessPartnerId,
    id,
    eMail,
    displayEMail = true,
    displayPhone = true,
    noButtonPadding = false,
  } = props || {};

  const completeTelephonenumbersNumbersRequest = useMemo<DataRequest>(() => {
    return {
      entity: Entities.contactTelephonenumbers,
      completeDataResponse: true,
      vars: {
        sdObjType: businessPartnerType,
        sdObjMemberCode: businessPartnerId,
        contactCode: id,
      },
      data: {
        central: null,
        directDial: null,
        directFax: null,
        fax: null,
        mobile: null,
        others: null,
        privateMobile: null,
        privateTelephone: null,
      } as ContactTelephonenumbers,
    };
  }, [businessPartnerId, businessPartnerType, id]);

  const completeTelephoneNumbersResponse = useDataProvider(
    completeTelephonenumbersNumbersRequest,
    !id || !businessPartnerId
  );

  const completeTelephoneNumbers =
    completeTelephoneNumbersResponse?.data as unknown as ContactTelephonenumbers;

  const { setCallModal } = useCallModalContext();

  const result = useMemo(() => {
    if (!id) {
      return null;
    }
    const actions = [];
    if (eMail && displayEMail)
      actions.push(
        <IconButton
          key="email"
          href={'mailto:' + eMail}
          sx={{ padding: noButtonPadding ? 0 : undefined }}
        >
          <EmailIcon color="primary" />
        </IconButton>
      );
    if (
      Object.keys(completeTelephoneNumbers).find(
        (key) =>
          !key.startsWith('__') &&
          completeTelephoneNumbers[key] !== null &&
          completeTelephoneNumbers[key].length > 0
      ) &&
      displayPhone
    )
      actions.push(
        <IconButton
          key="phone"
          sx={{ padding: noButtonPadding ? 0 : undefined }}
          onClick={() =>
            setCallModal({
              data: props,
              telephoneNumbers: completeTelephoneNumbers,
            })
          }
        >
          <PhoneIcon color="primary" />
        </IconButton>
      );

    return actions;
  }, [eMail, id, setCallModal, props, completeTelephoneNumbers]);

  return {
    actions: <Stack direction="row">{result}</Stack>,
    completeTelephoneNumbers,
  };
};
